import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text, Button, Box } from '@bigcommerce/big-design';

import { purchaseOrderAddItem } from '../../redux/actions/purchaseOrders';

const AddExternalItemModal = ({ payload, showAddExternalItemModal, setShowAddExternalItemModal, addItem }) => {
  const [name, setName] = useState(null);
  const [sku, setSku] = useState(null);
  const [price, setPrice] = useState(null);

  const changeName = (event) => {
    let value = event.target.value;
    setName(value);
  }

  const changeSku = (event) => {
    let value = event.target.value;
    setSku(value);
  }

  const changePrice = (event) => {
    let value = event.target.value;
    setPrice(value);
  }


  const update = () => {
    let itemData = {};

    itemData.productId = crypto.randomUUID();
    itemData.variantId = null;
    itemData.is_external = true;
    itemData.productName = name;
    itemData.supplier_sku = sku;
    itemData.supplier_price = price;
    itemData.minimumOrder = 1;

    addItem(payload, itemData);
    setShowAddExternalItemModal(false);

    setName(null);
    setSku(null);
    setPrice(null);
  }

  return (
    <>
      <Modal
        actions={[
          {
            text: 'Cancel',
            variant: 'subtle',
            onClick: () => setShowAddExternalItemModal(false),
          },
          { text: 'Add External Item', onClick: () => update() },
        ]}
        closeOnClickOutside={true}
        closeOnEscKey={true}
        header="Add External Item"
        isOpen={showAddExternalItemModal}
        onClose={() => setShowAddExternalItemModal(false)}
      >
        <Box
          backgroundColor="warning10"
          border="box"
          borderRadius="normal"
          padding="medium"
        >
          <div>
            <Text>Adding external items should be used sparingly, for products not tracked by your BigCommerce store.</Text>
          </div>
        </Box>

        <Input
          label="Item Name"
          onChange={changeName}
          placeholder="Item Name"
          type="text"
          value={name}
          required
        />
        
        <Input
          label="Supplier SKU"
          onChange={changeSku}
          placeholder="Supplier SKU"
          type="text"
          value={sku}
          required
        />

        <Input
          label="Price"
          onChange={changePrice}
          placeholder="Price"
          type="number"
          value={price}
          required
        />

      </Modal>
    </>
  )

}

const mapStateToProps = state => ({

});

const mapDispatchToProps = (dispatch) => ({
  addItem: (payload, itemData) => dispatch(purchaseOrderAddItem(payload, itemData))

});

export default connect(mapStateToProps, mapDispatchToProps)(AddExternalItemModal);
